"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
const react_1 = __importDefault(require("react"));
const Alert_1 = require("../Alert");
const Link_1 = require("../Link");
const Row_1 = require("../Row");
const Typography_1 = require("../Typography");
const Text = props => (react_1.default.createElement(Row_1.Row, null,
    react_1.default.createElement(Typography_1.Typography, Object.assign({}, props))));
const Banner = ({ children, ...props }) => {
    return (react_1.default.createElement(Alert_1.Alert, Object.assign({}, props),
        react_1.default.createElement(markdown_to_jsx_1.default, { options: {
                overrides: {
                    h1: {
                        component: Text,
                        props: { as: 'h1', size: 'lg', weight: 'bold' }
                    },
                    h2: {
                        component: Text,
                        props: { as: 'h2', size: 'md', weight: 'bold' }
                    },
                    h3: {
                        component: Text,
                        props: { as: 'h3', size: 'sm', weight: 'bold' }
                    },
                    h4: {
                        component: Text,
                        props: { as: 'h4', size: 'sm', weight: 'bold' }
                    },
                    h5: {
                        component: Text,
                        props: { as: 'h5', size: 'sm', weight: 'bold' }
                    },
                    h6: {
                        component: Text,
                        props: { as: 'h6', size: 'sm', weight: 'bold' }
                    },
                    p: {
                        component: Text,
                        props: { as: 'p' }
                    },
                    a: {
                        component: Link_1.Link
                    }
                }
            } }, `${children}`)));
};
exports.Banner = Banner;
//# sourceMappingURL=Banner.js.map